import React from "react";

const ScholarshipSection: React.FC = () => {
  return (
    <section id="moments-section">
      <div className="moments-header">
        <h2>
          One scholarship. Eighteen <br />
          months. <span className="red-highlight">One startup.</span>
        </h2>
        <p className="moments-intro">
          Through CcHUB's programs, 25,245 people gained new skills that are
          enhancing their productivity and creating new opportunities. The
          startups and institutions that grew within our innovation ecosystem
          served nearly 2 million more because we build the conditions that let
          impact compound beyond any single program. <br />
          <b>Here's what that compounding looks like for one person.</b>
        </p>
      </div>

      <div className="timeline-container">
        <div className="timeline-line"></div>

        {/* Item 1 */}
        <div className="timeline-item right">
          <div className="timeline-dot yellow"></div>
          <div className="timeline-content">
            <span className="timeline-tag">DIRECT OUTPUT</span>
            <h4>Scholarship to a game development program</h4>
            <p>
              A young man in Lagos receives a scholarship to study game
              development at SAIL Innovation Lab, a hub we support as part of
              our hub strengthening lever. He builds his first prototype and
              earns a certification.
            </p>
          </div>
        </div>

        {/* Item 2 */}
        <div className="timeline-item left">
          <div className="timeline-dot yellow"></div>
          <div className="timeline-content">
            <span className="timeline-tag orange">ECOSYSTEM EFFECT</span>
            <h4>Referral to Dimension 11 Studios</h4>
            <p>
              He's referred to Dimension 11, the team behind Legends of Orisha,
              and interns there for six months. The referral came through
              CcHUB's network.
            </p>
          </div>
        </div>

        {/* Item 3 */}
        <div className="timeline-item right">
          <div className="timeline-dot yellow"></div>
          <div className="timeline-content">
            <span className="timeline-tag orange">ECOSYSTEM EFFECT</span>
            <h4>Builds from the innovation hub</h4>
            <p>
              After the internship ends, he continues working from SAIL
              Innovation Lab. He enters a hackathon, impresses a mentor, and is
              introduced to a startup founder.
            </p>
          </div>
        </div>

        {/* Item 4 */}
        <div className="timeline-item center">
          <div className="timeline-dot green large"></div>
          <div className="timeline-content">
            <span className="timeline-tag green">COMPOUNDING RESULT</span>
            <h4 className="red-highlight">
              Co-founder and CTO of a game development startup
            </h4>
            <p>
              Eighteen months after that first scholarship,{" "}
              <b>
                he is co-founder and CTO of a startup building a social impact
                climate game.
              </b>{" "}
              CcHUB didn't start that company. But the developer who co-founded
              it came through our training, got his first industry experience
              through our referral, built his network in our space, and met his
              co-founder through our community.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScholarshipSection;
